import { MainInvitation } from "../screens/invitation";

const Invitation = () => <MainInvitation />;

export default Invitation;
